module.exports = __webpack_public_path__ + "static/cff06cb83638c0bbbae439cd49c7fd5718a138513f867fb1a6811490fe7feae4-c6a41d7723c6294ea994221f68fdb4b2.jpeg";